import script from "./changeModule.vue?vue&type=script&setup=true&lang=js"
export * from "./changeModule.vue?vue&type=script&setup=true&lang=js"

import "./changeModule.vue?vue&type=style&index=0&id=0b32305a&lang=css"

const __exports__ = script;

export default __exports__